( function () {
	'use strict';

	function obsFilters () {
		var directive = {
			'restrict'     : 'E',
			'templateUrl'  : '/templates/observations/observation-edit/filters/obs-filters.html',
			'controller'   : 'ObsFiltersCtrl',
			'controllerAs' : 'vm',
			'scope'        : {
				'filters'  : '=',
				'selected' : '=',
				'saveTags' : '='
			}
		};

		return directive;
	}

	angular
		.module( 'app.observations' )
		.directive( 'obsFilters', obsFilters );
} )( );
